import React, { useContext, useEffect, useState } from 'react'
import Rating from '@material-ui/lab/Rating';
import Typography from '@material-ui/core/Typography';
import { ContentBodyContext } from '../MainContent';
import { MessageContext } from './Message';
import TextareaAutosize from 'react-textarea-autosize';
import jwt from 'jwt-decode'
import swal from 'sweetalert'

function MessageFooter() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateMessage, dispatchMessage } = useContext(MessageContext)

    const handleGiveFeedbackButton = () => {
        dispatchMessage({
            type: 'MODAL_FEEDBACK',
            modalFeedback: { status: true, data: null }
        })
    }

    const handleInputChange = (event) => {
        setDataForm({
            ...dataForm,
            message: event.target.value,
            icon: event.target.value == '' ? `far fa-keyboard` : `far fa-paper-plane`
        })
    }

    const handleAttachmentClick = () => {
        dispatchMessage({
            type: "MODAL_ATTACH",
            modalAttachment: true
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if (dataForm.message != '' && !dataForm.isSubmitting) {
            setDataForm({
                ...dataForm,
                isSubmitting: true,
                icon: 'fas fa-spinner fa-pulse'
            })


            dispatchMessage({
                type: 'TRIGGER',
                trigger: { message: null, data: null, action: { name: 'footer', data: null } },
            })
            const jwtHelpdesk = jwt(localStorage.getItem('token-helpdesk-umy'))
            stateContentBody.socket.emit(`helpdesk-chat`, {
                id: jwtHelpdesk.id,
                token: localStorage.getItem('token-helpdesk-umy'),
                action: 'message',
                data: {
                    username: jwtHelpdesk.user,
                    message: dataForm.message,
                    parent_chat: stateMessage.selected,
                    chat_type: { sender: 'user', type: jwtHelpdesk.role_id == 'student' ? `student` : `staff` },
                    work_unit: stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).workunit.id,
                    file: null,
                    mimetype: null,
                    profile: {
                        status: jwtHelpdesk.role_id == 'student' || jwtHelpdesk.role_id == 'staff' ? jwtHelpdesk.role_id : 'admin',
                        id: jwtHelpdesk.id
                    }
                }
            })

        } else {
            swal("Error!", `Type your message before sending it!`, "error", {
                button: "OK",
            });
        }
    }

    useEffect(() => {
        if (stateMessage.selected != null) {
            if (stateMessage.trigger.message == "helpdesk-chat") {
                //TODO: statmessage.trigget.data = success / error
                setDataForm({ message: '', isSubmitting: false, icon: 'far fa-paper-plane' })
            } else if (stateMessage.trigger.message == "helpdesk-user-feedback-close" && stateMessage.trigger.action.data.sender == 'admin' && stateMessage.trigger.data == 'success' && stateMessage.selected == stateMessage.trigger.action.data.chat_id && stateMessage.trigger.action.name == 'close') {
                //close by admin
                setrenderFooter(
                    <div className="card-footer chat-form container p-3" style={{ minHeight: '50px' }}>
                        <div className="row justify-content-md-center">
                            <div className="col col-auto">
                                <button type="button" className="btn btn-primary col-auto" style={{ textTransform: 'capitalize', borderRadius: '10px' }} onClick={handleGiveFeedbackButton}>Give Feedback And Rating</button>
                            </div>
                        </div>
                    </div>
                )
                swal("Info!", "This message has been closed by admin!", "info", {
                    button: "OK",
                });
            }
        }
    }, [stateMessage.trigger])


    const [dataForm, setDataForm] = useState({ message: '', isSubmitting: false, icon: 'far fa-paper-plane' })
    const [renderFooter, setrenderFooter] = useState(
        <div className="card-footer chat-form">
            <form id="chat-form2" >
                <div style={{ height: '50px' }}>
                </div>
            </form>
        </div>)

    useEffect(() => {
        if (stateMessage.selected != null) {
            if (stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).status.id == 3 && stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).ratting == null) {
                setrenderFooter(
                    <div className="card-footer chat-form container p-3" style={{ minHeight: '50px' }}>
                        <div className="row justify-content-md-center">
                            <div className="col col-auto">
                                <button type="button" className="btn btn-primary col-auto" style={{ textTransform: 'capitalize', borderRadius: '10px' }} onClick={handleGiveFeedbackButton}>Give Feedback And Ratting</button>
                            </div>
                        </div>
                    </div>
                )
            }
            else if (stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).ratting != null) {
                setrenderFooter(
                    <div className="card-footer chat-form container p-3" style={{ minHeight: '50px' }}>
                        <div className="row justify-content-md-center">
                            <div className="col col-lg-8 col-md-8 col-sm-12">
                                <div className="form-group" >
                                    <Typography component="legend">Rating</Typography>
                                    <Rating
                                        style={{ fontSize: '3em' }}
                                        name="simple-controlled"
                                        value={stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).ratting}
                                        disabled={true}
                                    />
                                </div>
                                <div className="form-group">
                                    <Typography component="legend">Feedback</Typography>
                                    <textarea name="feedback" className="form-control" value={stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).feedback} style={{ height: '100px', border: 'solid' }} placeholder="Type your feedback here" readOnly></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            else {
                setrenderFooter(
                    <div className="card-footer chat-form">
                        <form id="chat-form2" onSubmit={handleSubmit}>
                            <TextareaAutosize minRows={1} maxRows={4} disabled={dataForm.isSubmitting || stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).status.id == 3 ? true : false} type="text" className="form-control " placeholder="Type a message..." id="message" name="message" value={dataForm.message} onChange={handleInputChange} style={{ paddingRight: '11vh' }} />
                            {dataForm.message == '' ? (<button type="button" className="btn btn-danger attachment" disabled={stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).status.id == 3 ? true : false} onClick={handleAttachmentClick}>
                                <i className="fa fa-paperclip" style={{ fontSize: '1.2em' }}></i>
                            </button>) : ''}
                            <button type="submit" disabled={dataForm.message == "" || dataForm.isSubmitting || stateMessage.listMessages.content.find(chat => chat.id == stateMessage.selected).status.id == 3 ? true : false} className="btn btn-primary submit">
                                <i className={dataForm.icon} style={{ fontSize: '1.2em' }} ></i>
                            </button>
                        </form>
                    </div>
                )
            }
        } else {
            setrenderFooter(
                <div className="card-footer chat-form">
                    <form id="chat-form2" >
                        <div style={{ height: '50px' }}>
                        </div>
                    </form>
                </div>
            )
        }
    }, [dataForm, stateMessage.listMessages, stateMessage.selected])

    return (renderFooter)
}

export default MessageFooter
